import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_SNMP_USERS = '/snmp-user';
export const API_PATH_SNMP_DESTS = '/snmp-destination';

export const GET_SNMP_USER = 'GET_SNMP_USER';
export const GET_SNMP_USER_FULFILLED = 'GET_SNMP_USER_FULFILLED';
export const GET_SNMP_USERS = 'GET_SNMP_USERS';
export const GET_SNMP_USERS_FULFILLED = 'GET_SNMP_USERS_FULFILLED';
export const GET_SNMP_USERS_REJECTED = 'GET_SNMP_USERS_REJECTED';
export const GET_SNMP_USERS_PENDING = 'GET_SNMP_USERS_PENDING';

export const SELECT_SNMP_USER = 'SELECT_SNMP_USER';

export const GO_TO_SNMP_USERS_CREATE = 'GO_TO_SNMP_USERS_CREATE';
export const GO_TO_SNMP_USERS_EDIT = 'GO_TO_SNMP_USERS_EDIT';
export const GO_TO_SNMP_USERS_VIEW = 'GO_TO_SNMP_USERS_VIEW';
export const GO_TO_SNMP_USERS_LIST = 'GO_TO_SNMP_USERS_LIST';

export const CREATE_SNMP_USER = 'CREATE_SNMP_USER';
export const CREATE_SNMP_USER_PENDING = 'CREATE_SNMP_USER_PENDING';
export const CREATE_SNMP_USER_FULFILLED = 'CREATE_SNMP_USER_FULFILLED';
export const CREATE_SNMP_USER_REJECTED = 'CREATE_SNMP_USER_REJECTED';

export const DELETE_SNMP_USER = 'DELETE_SNMP_USER';
export const DELETE_SNMP_USER_FULFILLED = 'DELETE_SNMP_USER_FULFILLED';
export const DELETE_SNMP_USER_REJECTED = 'DELETE_SNMP_USER_REJECTED';

export const UPDATE_SNMP_USER = 'UPDATE_SNMP_USER';
export const UPDATE_SNMP_USER_FULFILLED = 'UPDATE_SNMP_USER_FULFILLED';
export const UPDATE_SNMP_USER_REJECTED = 'UPDATE_SNMP_USER_REJECTED';

export const GET_SNMP_DEST = 'GET_SNMP_DEST';
export const GET_SNMP_DEST_FULFILLED = 'GET_SNMP_DEST_FULFILLED';
export const GET_SNMP_DESTS = 'GET_SNMP_DESTS';
export const GET_SNMP_DESTS_FULFILLED = 'GET_SNMP_DESTS_FULFILLED';
export const GET_SNMP_DESTS_REJECTED = 'GET_SNMP_DESTS_REJECTED';
export const GET_SNMP_DESTS_PENDING = 'GET_SNMP_DESTS_PENDING';

export const SELECT_SNMP_DEST = 'SELECT_SNMP_DEST';

export const GO_TO_SNMP_DESTS_CREATE = 'GO_TO_SNMP_DESTS_CREATE';
export const GO_TO_SNMP_DESTS_EDIT = 'GO_TO_SNMP_DESTS_EDIT';
export const GO_TO_SNMP_DESTS_VIEW = 'GO_TO_SNMP_DESTS_VIEW';
export const GO_TO_SNMP_DESTS_LIST = 'GO_TO_SNMP_DESTS_LIST';

export const CREATE_SNMP_DEST = 'CREATE_SNMP_DEST';
export const CREATE_SNMP_DEST_PENDING = 'CREATE_SNMP_DEST_PENDING';
export const CREATE_SNMP_DEST_FULFILLED = 'CREATE_SNMP_DEST_FULFILLED';
export const CREATE_SNMP_DEST_REJECTED = 'CREATE_SNMP_DEST_REJECTED';

export const DELETE_SNMP_DEST = 'DELETE_SNMP_DEST';
export const DELETE_SNMP_DEST_FULFILLED = 'DELETE_SNMP_DEST_FULFILLED';
export const DELETE_SNMP_DEST_REJECTED = 'DELETE_SNMP_DEST_REJECTED';

export const UPDATE_SNMP_DEST = 'UPDATE_SNMP_DEST';
export const UPDATE_SNMP_DEST_FULFILLED = 'UPDATE_SNMP_DEST_FULFILLED';
export const UPDATE_SNMP_DEST_REJECTED = 'UPDATE_SNMP_DEST_REJECTED';

export enum SnmpUserPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access'
}
export enum SnmpDestPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access'
}
export enum SnmpUserActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}
export enum SnmpDestActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}
export interface SnmpState {
  snmpUsers: SnmpV3User[];
  singleUser: SnmpV3User | null;
  selectedUser: SnmpV3User | null;
  snmpDests: SnmpDestination[];
  singleDest: SnmpDestination | null;
  selectedDest: SnmpDestination | null;
}
export interface SnmpV3User {
  id: string;
  USERNAME: string;
  AUTHPASSWD: string;
  PRIVPASSWD: string;
  SECURITYLVL: 'NOAUTHNOPRIV' | 'AUTHNOPRIV' | 'AUTHPRIV';
  HASHTYPE: 'MD5' | 'SHA';
  PRIVPROTO: 'DES' | 'AES';
}
export interface SnmpDestination {
  id: string;
  DESTID?: string;
  NAME: string;
  VERSION: 'SNMPV2C' | 'SNMPV3';
  SECURITYNAME: string;
  DESTIP: string;
  DESTPORT: string;
  OWNIP?: string;
  OWNPORT: string;
  REQSTATE: 'INACTIVE' | 'ACTIVE';
}

export interface SnmpDestinationUI extends SnmpDestination {
  SECURITYNAMEV3: string;
}

export interface GetSnmpUserAction extends AnyAction {
  type: typeof GET_SNMP_USER;
  payload: AxiosPromise<ServerResponse<SnmpV3User>>;
}

export interface GetSnmpUserFulfilledAction extends AnyAction {
  type: typeof GET_SNMP_USER_FULFILLED;
  payload: AxiosResponse<ServerResponse<SnmpV3User>>;
}

export interface GetSnmpUsersAction extends AnyAction {
  type: typeof GET_SNMP_USERS;
  payload: AxiosPromise<ServerResponse<SnmpV3User>>;
}

export interface GetSnmpUsersFulfilledAction extends AnyAction {
  type: typeof GET_SNMP_USERS_FULFILLED;
  payload: AxiosResponse<ServerResponse<SnmpV3User>>;
}

export interface CreateSnmpUserThunkAction
  extends ThunkAction<void, RootState, void, AnyAction> {}
export interface CreateSnmpUserAction extends AnyAction {
  type: typeof CREATE_SNMP_USER;
  payload: AxiosPromise<ServerResponse<SnmpV3User>>;
}

export interface CreateSnmpUserPendingAction extends AnyAction {
  type: typeof CREATE_SNMP_USER_PENDING;
  payload: null;
}

export interface CreateSnmpUserFulfilledAction extends AnyAction {
  type: typeof CREATE_SNMP_USER_FULFILLED;
  payload: AxiosResponse<ServerResponse<SnmpV3User>>;
}

export interface CreateSnmpUserRejectedAction extends AnyAction {
  type: typeof CREATE_SNMP_USER_REJECTED;
  payload: AxiosResponse<ServerResponse<SnmpV3User>>;
}

export interface DeleteSnmpUserThunkAction
  extends ThunkAction<void, RootState, void, AnyAction> {}
export interface DeleteSnmpUserAction extends AnyAction {
  type: typeof DELETE_SNMP_USER;
  payload: AxiosPromise<ServerResponse<SnmpV3User>>;
}

export interface DeleteSnmpUserFulfilledAction extends AnyAction {
  type: typeof DELETE_SNMP_USER_FULFILLED;
  payload: AxiosResponse<ServerResponse<SnmpV3User>>;
}

export interface DeleteSnmpUserRejectedAction extends AnyAction {
  type: typeof DELETE_SNMP_USER_REJECTED;
  payload: AxiosResponse<ServerResponse<SnmpV3User>>;
}

export interface UpdateSnmpUserThunkAction
  extends ThunkAction<void, RootState, void, AnyAction> {}
export interface UpdateSnmpUserAction extends AnyAction {
  type: typeof UPDATE_SNMP_USER;
  payload: AxiosPromise<ServerResponse<SnmpV3User>>;
}

export interface UpdateSnmpUserFulfilledAction extends AnyAction {
  type: typeof UPDATE_SNMP_USER_FULFILLED;
  payload: AxiosResponse<ServerResponse<SnmpV3User>>;
}

export interface UpdateSnmpUserRejectedAction extends AnyAction {
  type: typeof UPDATE_SNMP_USER_REJECTED;
  payload: AxiosResponse<ServerResponse<SnmpV3User>>;
}

export interface SelectSnmpUserAction extends AnyAction {
  type: typeof SELECT_SNMP_USER;
  payload: SnmpV3User;
}

export function selectSnmpUser(snmpUser: SnmpV3User): SelectSnmpUserAction {
  return {
    type: SELECT_SNMP_USER,
    payload: snmpUser
  };
}

export interface GetSnmpDestAction extends AnyAction {
  type: typeof GET_SNMP_DEST;
  payload: AxiosPromise<ServerResponse<SnmpDestination>>;
}

export interface GetSnmpDestFulfilledAction extends AnyAction {
  type: typeof GET_SNMP_DEST_FULFILLED;
  payload: AxiosResponse<ServerResponse<SnmpDestination>>;
}

export interface GetSnmpDestsAction extends AnyAction {
  type: typeof GET_SNMP_DESTS;
  payload: AxiosPromise<ServerResponse<SnmpDestination>>;
}

export interface GetSnmpDestsFulfilledAction extends AnyAction {
  type: typeof GET_SNMP_DESTS_FULFILLED;
  payload: AxiosResponse<ServerResponse<SnmpDestination>>;
}

export interface CreateSnmpDestThunkAction
  extends ThunkAction<void, RootState, void, AnyAction> {}
export interface CreateSnmpDestAction extends AnyAction {
  type: typeof CREATE_SNMP_DEST;
  payload: AxiosPromise<ServerResponse<SnmpDestination>>;
}

export interface CreateSnmpDestPendingAction extends AnyAction {
  type: typeof CREATE_SNMP_DEST_PENDING;
  payload: null;
}

export interface CreateSnmpDestFulfilledAction extends AnyAction {
  type: typeof CREATE_SNMP_DEST_FULFILLED;
  payload: AxiosResponse<ServerResponse<SnmpDestination>>;
}

export interface CreateSnmpDestRejectedAction extends AnyAction {
  type: typeof CREATE_SNMP_DEST_REJECTED;
  payload: AxiosResponse<ServerResponse<SnmpDestination>>;
}

export interface DeleteSnmpDestThunkAction
  extends ThunkAction<void, RootState, void, AnyAction> {}
export interface DeleteSnmpDestAction extends AnyAction {
  type: typeof DELETE_SNMP_DEST;
  payload: AxiosPromise<ServerResponse<SnmpDestination>>;
}

export interface DeleteSnmpDestFulfilledAction extends AnyAction {
  type: typeof DELETE_SNMP_DEST_FULFILLED;
  payload: AxiosResponse<ServerResponse<SnmpDestination>>;
}

export interface DeleteSnmpDestRejectedAction extends AnyAction {
  type: typeof DELETE_SNMP_DEST_REJECTED;
  payload: AxiosResponse<ServerResponse<SnmpDestination>>;
}

export interface UpdateSnmpDestThunkAction
  extends ThunkAction<void, RootState, void, AnyAction> {}
export interface UpdateSnmpDestAction extends AnyAction {
  type: typeof UPDATE_SNMP_DEST;
  payload: AxiosPromise<ServerResponse<SnmpDestination>>;
}

export interface UpdateSnmpDestFulfilledAction extends AnyAction {
  type: typeof UPDATE_SNMP_DEST_FULFILLED;
  payload: AxiosResponse<ServerResponse<SnmpDestination>>;
}

export interface UpdateSnmpDestRejectedAction extends AnyAction {
  type: typeof UPDATE_SNMP_DEST_REJECTED;
  payload: AxiosResponse<ServerResponse<SnmpDestination>>;
}

export interface SelectSnmpDestAction extends AnyAction {
  type: typeof SELECT_SNMP_DEST;
  payload: SnmpDestination;
}

export function selectSnmpDest(
  snmpUser: SnmpDestination
): SelectSnmpDestAction {
  return {
    type: SELECT_SNMP_DEST,
    payload: snmpUser
  };
}

export type SnmpActionTypes =
  | GetSnmpUserAction
  | GetSnmpUserFulfilledAction
  | GetSnmpUsersAction
  | GetSnmpUsersFulfilledAction
  | CreateSnmpUserAction
  | CreateSnmpUserPendingAction
  | CreateSnmpUserFulfilledAction
  | CreateSnmpUserRejectedAction
  | DeleteSnmpUserAction
  | DeleteSnmpUserFulfilledAction
  | DeleteSnmpUserRejectedAction
  | UpdateSnmpUserAction
  | UpdateSnmpUserFulfilledAction
  | UpdateSnmpUserRejectedAction
  | SelectSnmpUserAction
  | GetSnmpDestAction
  | GetSnmpDestFulfilledAction
  | GetSnmpDestsAction
  | GetSnmpDestsFulfilledAction
  | CreateSnmpDestAction
  | CreateSnmpDestPendingAction
  | CreateSnmpDestFulfilledAction
  | CreateSnmpDestRejectedAction
  | DeleteSnmpDestAction
  | DeleteSnmpDestFulfilledAction
  | DeleteSnmpDestRejectedAction
  | UpdateSnmpDestAction
  | UpdateSnmpDestFulfilledAction
  | UpdateSnmpDestRejectedAction
  | SelectSnmpDestAction;
